import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, cloneDeep } from 'lodash';
import { Box, Grid } from '@mui/material';
import RenderGridv3 from '../../components/RenderGrid';
import useTimeStore from '../../components/ZustandProvider';
import { useStyles } from '../../../styles/mapStylesCustom';
import { mobileTemplate } from '../../../modules/layoutPlantilla';

const NewLayout = props => {
  const { changeLoading, isPublicMap, MapProps } = props;

  const data = useTimeStore(state => state.data);
  const setData = useTimeStore(state => state.setData);
  const layers = useTimeStore(state => state.layers);
  const setLayers = useTimeStore(state => state.setLayers);
  const layersTrans = useTimeStore(state => state.layersTrans);
  const setLayersTrans = useTimeStore(state => state.setLayersTrans);

  const verifyCookies = () => {
    const result = document.cookie.match(new RegExp(`layers${MapProps.map.publicId}=([^;]+)`));
    if (!isEmpty(result)) {
      const layerListFromCookies = JSON.parse(result[1]);
      const layerList = MapProps.layers.map(item => {
        const index = layerListFromCookies.findIndex(x => x._id === item._id);
        if (index >= 0) {
          return { ...item, ...layerListFromCookies[index] };
        }
        return item;
      });
      return layerList;
    }
    return MapProps.layers;
  };

  React.useEffect(() => {
    if (!isEmpty(layers)) {
      const layersProps = layers.map(element => {
        const picked = (({ _id, url, styleValue }) => ({ _id, url, styleValue }))(element);
        return picked;
      });
      const expires = new Date(Date.now() + 86400 * 1000 * 14).toUTCString();
      const cookie = [
        'layers',
        MapProps.map.publicId,
        '=',
        JSON.stringify(layersProps),
        '; path=',
        window.location.pathname.toString(),
        '; expires=',
        expires
      ].join('');
      document.cookie = cookie;
    }
  }, [layers]);

  const classes = useStyles();
  const gridJson = MapProps.map.layoutJson;

  const layersTransparencyInitialArray = MapProps.map.layers.map(item => {
    const propiedades = {
      id: item,
      value: 0.8
    };
    return propiedades;
  });

  const newmap = isEmpty(layersTrans)
    ? { ...MapProps.map }
    : { ...MapProps.map, layersTransparency: layersTrans };

  const newMapProps = () => {
    let propsLocales = newMapProps;
    if (isEmpty(layers)) {
      propsLocales = isEmpty(layersTrans) ? { ...MapProps } : { ...MapProps, map: newmap };
    } else {
      propsLocales = isEmpty(layersTrans)
        ? { ...MapProps, layers }
        : { ...MapProps, map: newmap, layers };
    }
    return propsLocales;
  };

  React.useEffect(() => {
    if (isEmpty(layers)) {
      const result = document.cookie.match(new RegExp(`layers${MapProps.map.publicId}=([^;]+)`));
      if (!isEmpty(result)) {
        const value = verifyCookies();
        setLayers(value);
      } else {
        setLayers(cloneDeep(MapProps.layers));
      }
    }
    if (isEmpty(layersTrans)) {
      if (isEmpty(MapProps.map.layersTransparency)) {
        MapProps.map.layersTransparency = layersTransparencyInitialArray;
      }
      setLayersTrans(cloneDeep(MapProps.map.layersTransparency));
    }
    if (isEmpty(data)) {
      if (window.innerWidth < 500) {
        setData(mobileTemplate);
      } else {
        setData(gridJson);
      }
    } else {
      setData(data);
    }
  }, [data]);

  return (
    <>
      <div>
        {isPublicMap ? (
          <>
            {!isEmpty(data) && (
              <Grid container direction="row" width="100%">
                <Grid item xs={12} paddingX={0}>
                  <div>
                    <RenderGridv3
                      changeLoading={changeLoading}
                      isPublicMap={isPublicMap}
                      map={MapProps.map}
                      MapProps={newMapProps()}
                      {...data}
                    />
                  </div>
                </Grid>
              </Grid>
            )}
          </>
        ) : (
          <>
            {!isEmpty(data) && (
              <Grid container direction="row" className={classes.margenes} spacing={2}>
                <Grid item xs={12}>
                  <Box className={classes.rootplus}>
                    <RenderGridv3
                      changeLoading={changeLoading}
                      isPublicMap={isPublicMap}
                      map={MapProps.map}
                      MapProps={newMapProps()}
                      {...data}
                    />
                  </Box>
                </Grid>
              </Grid>
            )}
          </>
        )}
      </div>
    </>
  );
};
NewLayout.defaultProps = {
  changeLoading: () => {},
  isPublicMap: {},
  MapProps: {}
};
NewLayout.propTypes = {
  changeLoading: PropTypes.func,
  isPublicMap: PropTypes.bool,
  MapProps: PropTypes.object
};
export default NewLayout;
